
/* injects from baggage-loader */

'use strict';

import lockUnlockFiltersTpl from '!!file-loader?name=templates/[name].[ext]!./lockUnlockFilters.html';
import _ from 'lodash';

/**
 *	Directive used for manipulate the HTML DOM elements inside the lockUnlockFiltersSelect component
 * @returns
 */
function lockUnlockFiltersComponent() {

	/**
	 * Directive definition.
	 */
	const directive = {
		restrict: 'E',
		templateUrl: lockUnlockFiltersTpl,
		controller: LockUnlockFiltersController,
		controllerAs: 'lockUnlockFiltersvm',
		scope: {
			filters: '=',
			getComponents: '&',
			unlock: '@'
		},
		bindToController: true
	};

	return directive;

	/**
	 * Controller used by lockUnlockFilters directive
	 */
	function LockUnlockFiltersController(lockUnlockFiltersConstant, utilitiesConstant, restClientServices, utilitiesFactory) {
		'ngInject';

		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		let vm = this;
		vm.lockUnlockFiltersConstant = lockUnlockFiltersConstant;

		vm.principalCashier = null;
		vm.cashier = null;
		vm.seller = null;

		vm.campaigns = [];
		vm.offices = [];
		vm.cashiers = [];
		vm.sellers = [];
		vm.statuses = [];

		/**
		 * Filter campaigns by code and name
		 * @param {*} searchText
		 */
		vm.searchCampaign = searchText => vm.campaigns.filter(campaign => _.includes(campaign.name.toLowerCase(), searchText.toLowerCase()) || _.includes(campaign.id, searchText));

		/**
		 * Filter offices by code and name
		 * @param {*} searchText
		 */
		vm.searchOffice = searchText => vm.offices.filter(office => _.includes(office.name.toLowerCase(), searchText.toLowerCase()) || _.includes(office.code, searchText));

		/**
		 * Filter cashiers by name and id
		 * @param {*} searchText
		 */
		vm.searchCashier = searchText => vm.cashiers.filter(cashier => _.includes(cashier.name.toLowerCase(), searchText.toLowerCase()) || _.includes(cashier.identification, searchText));

		/**
		 * Filter sellers by name and id
		 * @param {*} searchText
		 */
		vm.searchSeller = searchText => vm.sellers.filter(seller => _.includes(seller.name.toLowerCase(), searchText.toLowerCase()) || _.includes(seller.identification, searchText));

		/**
		 * Filter statuses by code and name
		 * @param {*} searchText
		 */
		vm.searchStatus = searchText => vm.statuses.filter(status => _.includes(status.name.toLowerCase(), searchText.toLowerCase()) || _.includes(status.code, searchText));

		/**
		 * Gets the sellers and cashiers based on the selected office
		 */
		vm.updateSellersCashiers = () => {
			if (vm.filters.office === null) {
				vm.principalCashier = null;
				vm.cashier = null;
				vm.seller = null;
				vm.cashiers = [];
				vm.sellers = [];
			} else {
				const sellersCashiersUrl = utilitiesConstant.URL_ENDPOINT_GANA.concat(utilitiesConstant.URL_API_METHOD.SELLERS_CASHIERS);
				restClientServices.ganaService(sellersCashiersUrl, { userId: vm.filters.office.code })
					.then(response => {
						vm.sellers = response.sellers;
						vm.cashiers = response.cashiers;
					},
					error);
			}
		}

		/**
		 * Set and validate the responsible the it invokes a function to get the components
		 */
		vm.invokeParentFunction = () => {
			if (vm.filters.campaign === null) {
				utilitiesFactory.showAlertMessage(lockUnlockFiltersConstant.NO_SELECTED_CAMPAIGN);
				return;
			}

			vm.filters.responsible = null;
			if (vm.principalCashier !== null) {
				if (vm.cashier === null && vm.seller === null) {
					vm.filters.responsible = vm.principalCashier;
				} else {
					utilitiesFactory.showAlertMessage(lockUnlockFiltersConstant.MULTIPLE_RESPONSIBLES);
					return;
				}
			}

			if (vm.cashier !== null) {
				if (vm.principalCashier === null && vm.seller === null) {
					vm.filters.responsible = vm.cashier;
				} else {
					utilitiesFactory.showAlertMessage(lockUnlockFiltersConstant.MULTIPLE_RESPONSIBLES);
					return;
				}
			}
			if (vm.seller !== null) {
				if (vm.principalCashier === null && vm.cashier === null) {
					vm.filters.responsible = vm.seller;
				} else {
					utilitiesFactory.showAlertMessage(lockUnlockFiltersConstant.MULTIPLE_RESPONSIBLES);
					return;
				}
			}
			vm.getComponents();
		}

		(function () {
			/**
			 * Gets campaigns, offices and statuses from the server.
			 */
			const campaignsUrl = utilitiesConstant.URL_ENDPOINT.concat(utilitiesConstant.URL_API_METHOD.CAMPAIGNS);
			const officesUrl = utilitiesConstant.URL_ENDPOINT_GANA.concat(utilitiesConstant.URL_API_METHOD.ALL_OFFICES);
			const statusUrl = utilitiesConstant.URL_ENDPOINT.concat(utilitiesConstant.URL_API_METHOD.LOCK_UNLOCK_COMPONENTS.STATUSES);
			restClientServices.queryService(campaignsUrl)
				.then(response => {
					vm.campaigns = response;
				},
				error);
			restClientServices.ganaService(officesUrl)
				.then(response => {
					vm.offices = response.offices;
				},
				error);
			restClientServices.queryService(statusUrl)
				.then(response => {
					vm.statuses = response;
				},
				error);
		})();

		function error(error) {
			if (error.status === 404) {
				utilitiesFactory.showErrorMessage(lockUnlockFiltersConstant.NOT_FOUND);
			} else {
				utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
			}
		}
	}
}

export default lockUnlockFiltersComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/lockUnlockFilters/lockUnlockFilters.directive.js